import { styled } from '@linaria/react';
import { semantic, size } from '../../theme/tokens';

export const Block = styled.div`
  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }

  background: linear-gradient(
    90deg,
    ${semantic.bg.surfaceSubtle} 25%,
    ${semantic.bg.surfaceDefault} 50%,
    ${semantic.bg.surfaceSubtle} 75%
  );
  background-size: 800px 100%;
  animation: shimmer 1.4s ease-in-out infinite;
  border-radius: ${size.radius['radius-xs']};
  display: block;
`;
